module.exports = __webpack_public_path__ + "assets/img/main-logo-langfang.3c5b6fc8.png";